import React, { Component } from "react";
import "../css/agent.css";
import { Table, Glyphicon } from 'react-bootstrap';
import { UserService } from "../Services/UserService";
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import { openMap, toInt } from "../Utils";
import { RowCountOptions } from "../Config";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import AddCustomer from "./AddCustomer";
import { ROLES } from "../Roles";
import { Fab } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { STATES } from "../Constants";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
});

class Customer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            originalData: [],
            current_rows: [],
            numItemsPerPage: 10,
            currentPageNumber: 0,
            totalItems: 0,
            totalPages: 0,
            filter: '',
            columns: [
                { id: 'name', align: "left", numeric: false, disablePadding: false, label: 'Name', sortable: true },
                { id: 'mobile_no', align: "center", numeric: false, disablePadding: false, label: 'Mobile No', sortable: true },
                { id: 'flat', align: "left", numeric: false, disablePadding: false, label: 'Address', sortable: true },
                { id: 'email', numeric: false, disablePadding: false, label: 'Email', sortable: false },
                { id: 'building_name', numeric: false, disablePadding: false, label: 'Route Name', sortable: false },
                { id: 'state', numeric: false, disablePadding: false, label: 'state', sortable: false },
                { id: 'user_balance', numeric: true, disablePadding: false, label: 'User Balance', sortable: false },
                { id: 'actions', numeric: false, disablePadding: false, label: 'VIP', sortable: false },
            ],
            order: 'asc',
            orderBy: 'name',
            open: false,
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.filterCriteria = this.filterCriteria.bind(this);
        this.addtag = this.addtag.bind(this);
        this.newCustomer = this.newCustomer.bind(this);
        this.fetchCount = this.fetchCount.bind(this);
    }

    componentDidMount() {
        this.props.isLoading(true);
        this.fetchCount();
    }

    fetchCount() {
        UserService.getTotalCount("CUSTOMER")
            .then((data) => {
                console.log(data);
                if (data) {
                    this.setState({
                        totalItems: toInt(data.count),
                        totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
                    });
                    this.props.setTitle(`Customers - ${data.count}`);
                }
                this.props.isLoading(false);
            })
            .then(() => this.fetchData(0, this.state.numItemsPerPage))
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    addtag(e, user, tag) {
        console.log(user, tag);
        e.preventDefault();
        UserService.addTag(user.id, tag)
            .then((data) => {
                console.log(data);
                user.tags = user.tags.filter(t => t !== tag);
                const status = data.tags.includes(tag);
                this.props.showSnackBar(`${status ? "Marked" : "Unmarked"} Customer ${user.name} as ${tag}`, 'info');
                this.state.filter ? this.filterCriteria() : this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            })
            .catch(error => console.log(error));
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage: event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if (this.state.currentPageNumber > page) {
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems, filter = '') {
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        UserService.getCustomers(start, numberItems, filter, sort, direction)
            .then((data) => {
                console.log(data);
                this.setState({ data: data.users, originalData: data.users });
                data.users.forEach((user) => {
                    rows.push(<UserDetails key={user.id} user={user} addtag={this.addtag} edit={this.newCustomer} />);
                });
                this.setState({
                    current_rows: rows
                });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    filterCriteria(e) {
        if (e)
            e.preventDefault();
        const searchText = e ? e.target.value : this.state.filter;
        this.setState({ filter: searchText }, () => this.fetchData(0, this.state.numItemsPerPage, searchText));
    }

    handleSelect(eventKey, e) {
        if (eventKey === 'prev') {
            if ((this.state.currentPageNumber) > 0) {
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if (eventKey === 'next') {
            if ((this.state.currentPageNumber) < this.state.totalPages) {
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage) {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.filter);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    newCustomer(e, customer){
        this.setState({ open: true, id: customer ? customer.id: null });
    }

    render() {
        let message = this.state.message;
        return (
            <div className="Home">
                <div className="container">
                    <p style={{ color: "red", paddingLeft: "20px" }}>{message}</p>
                    {!message &&
                        <Paper className={this.props.classes.root} style={{ width: "100%", marginTop: 5, paddingLeft: 5, paddingRight: 5, marginBottom: 80 }}>
                            <EnhancedTableToolbar
                                //exportReport={this.export}
                                onSearchTextChange={this.filterCriteria}
                                searchText={this.state.filter}
                                loading={this.props.loading}
                            />
                            <Table striped condensed hover responsive>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows={this.state.columns} />
                                <TableBody>
                                    {this.state.current_rows}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </Paper>
                    }
                </div>
                {   this.props.user.roles.includes(ROLES.ADMIN) && 
                    <Fab variant="extended" onClick={this.newCustomer} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', bottom: '5%', right: '5%'}}>
                        <AddIcon />
                        Add Customer
                    </Fab>
                }
                <AddCustomer
                    {...this.props}
                    id={this.state.id}
                    open={this.state.open || false}
                    maxWidth={"sm"}
                    fullWidth={true}
                    user={this.props.user} 
                    close={(success) => {
                        this.setState({id: null, open: false})
                        if(success){
                            this.fetchCount()
                        }
                    }}
                    />
            </div>
        );
    }

}

class UserDetails extends Component {

    render() {
        const user = this.props.user;
        //   const format = 'YYYY-MM-DD HH:mm:SS';
        //   const time = moment(location.time, format);
        return (
            <tr>
                <td align="left">{user.name}</td>
                <td align="center">{user.mobile_no}</td>
                <td align="justify" style={{width: '30vw'}}>{user.flat}</td>
                <td align="center">{user.email || '-'}</td>
                <td align="center">{user.route_name}</td>
                <td align="center">{user.state ? STATES.find(s => s.code === user.state).name : '-'}</td>
                <td align="right">{user.user_balance}</td>
                <td>
                    <Tooltip arrow title="Click to change VIP status">
                        <Glyphicon glyph="star" onClick={(e) => this.props.addtag(e, user, "VIP")} style={{ color: user.tags.includes("VIP") ? "#FFDF00" : "#BDBDBD" }} />
                    </Tooltip>
                    <Tooltip arrow title="Click to Edit">
                        <Glyphicon glyph="pencil" onClick={(e) => this.props.edit(null, user)} style={{ marginLeft: 8 }} />
                    </Tooltip>
                    {
                        user.location && (
                            <Tooltip arrow title="View location on Map">
                                <Glyphicon glyph="map-marker" onClick={(e) => openMap(user.location)} style={{ marginLeft: 8 }} />
                            </Tooltip>
                        )
                    }
                </td>
            </tr>
        );
    }
}

export default withStyles(styles)(Customer);